/* Provider links reuse the existing Google Calendar event without changing its URL. */
if (!customElements.get('rdv7-calendar-dropdown')) {
  customElements.define('rdv7-calendar-dropdown', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const menu = this.querySelector('.rdv7-calendar-menu');
      const google = this.querySelector('[data-calendar-google]');
      if (!details || !google) return;
      const params = new URL(google.href).searchParams;
      const [start, end] = (params.get('dates') || '').split('/');
      const iso = value => value.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(Z?)$/, '$1-$2-$3T$4:$5:$6$7');
      const title = params.get('text') || '';
      const location = params.get('location') || '';
      const description = params.get('details') || '';
      const addLink = (label, href, download) => {
        const link = document.createElement('a');
        link.textContent = label;
        link.href = href;
        link.dataset.calendarProvider = '';
        if (download) link.download = download;
        else { link.target = '_blank'; link.rel = 'noopener noreferrer'; }
        menu.append(link);
      };
      menu.querySelectorAll('[data-calendar-provider]').forEach(link => link.remove());
      const outlook = new URLSearchParams({ path: '/calendar/action/compose', rru: 'addevent', subject: title, startdt: iso(start), enddt: iso(end), location, body: description });
      addLink('Outlook.com', 'https://outlook.live.com/calendar/0/deeplink/compose?' + outlook);
      addLink('Office 365', 'https://outlook.office.com/calendar/0/deeplink/compose?' + outlook);
      addLink('Yahoo Calendar', 'https://calendar.yahoo.com/?' + new URLSearchParams({ v: '60', view: 'd', type: '20', title, st: start, et: end, desc: description, in_loc: location }));
      const escape = value => value.replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
      // RFC 5545 folds content lines at 75 octets, without splitting UTF-8 characters.
      const fold = line => {
        let result = '', size = 0;
        for (const character of line) {
          const bytes = new TextEncoder().encode(character).length;
          if (size + bytes > 75) { result += '\r\n '; size = 1; }
          result += character; size += bytes;
        }
        return result;
      };
      const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
      const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Allure Commerce//Retail Deluxe//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', 'UID:' + start + '-retail-deluxe@' + location.replace(/[^a-z0-9]/gi, '').toLowerCase() + '.event', 'DTSTAMP:' + stamp, 'DTSTART:' + start, 'DTEND:' + end, 'SUMMARY:' + escape(title), 'DESCRIPTION:' + escape(description), 'LOCATION:' + escape(location), 'END:VEVENT', 'END:VCALENDAR'];
      this.calendarUrl = URL.createObjectURL(new Blob([lines.map(fold).join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' }));
      addLink('Apple / iCal (.ics)', this.calendarUrl, 'retail-deluxe-nyc.ics');
      details.addEventListener('toggle', () => {
        if (details.open) document.querySelectorAll('rdv7-calendar-dropdown details[open]').forEach(other => { if (other !== details) other.open = false; });
      }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) details.open = false; }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) { details.open = false; summary.focus(); }
      }, options);
      menu.addEventListener('click', event => { if (event.target.closest('a')) details.open = false; }, options);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.calendarUrl) URL.revokeObjectURL(this.calendarUrl);
    }
  });
}
